/**
 * @desc Helper to check if the supplied parameter is of type string with a length > 0
 * @param str
 * @returns {boolean}
 */
export const isStringNullOrWhitespace = (str) => (typeof str !== 'string' || str.trim().length <= 0);

export default {}
